import { Fragment, ReactNode } from 'react';

export type ConversationRole =
  | 'fushima'
  | 'fushima-happy'
  | 'amana'
  | 'amana-confused'
  | 'amana-proud'
  | 'raiphen'
  | 'ciel'
  | 'maehr'
  | 'isth'
  | 'chara-normal'
  | 'chara-happy'
  | 'chara-talk'
  | 'chara-surprized';

type UseConversationProps = {
  avatar?: boolean;
  role: ConversationRole;
  children: ReactNode;
};

export const useConversation = ({ avatar, role, children }: UseConversationProps) => {
  const displayAvatar = avatar === undefined || avatar === true;

  // roleからキャラクターの表示名を取得
  const name = role.includes('amana')
    ? 'アマナ'
    : role.includes('fushima')
    ? 'フシマ'
    : role === 'raiphen'
    ? 'ライプン'
    : role === 'ciel'
    ? 'シエル'
    : role === 'maehr'
    ? 'メーア'
    : role === 'isth'
    ? 'イスト'
    : role.includes('chara')
    ? 'あなた'
    : '';

  // childrenをそのまま表示するか、文字列の場合は\n区切りで処理
  const body =
    typeof children === 'string'
      ? children.split('\n').map((string, index) => (
          <Fragment key={index}>
            {index !== 0 && <br />}
            {string}
          </Fragment>
        ))
      : children;

  return { displayAvatar, name, role, body };
};
